import RefereeDetailsScreen from './RefereeDetailsScreen';

export default RefereeDetailsScreen;
